var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[(_vm.isPc)?_c('p-c-index-page'):_c('mobile-index-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }